<template>
    <div class="contenedor">
        <div v-if="loading">
            <loader></loader>
        </div>
        <b-row>
            <b-col sm="6">
                <span class="titulo">Producto A: <span class="productoNom">{{ producto1.nombre }}</span></span>
            </b-col>
            <b-col sm="6">
                <span class="titulo">Producto B: <span class="productoNom">{{ producto2.nombre }}</span></span>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col sm="6" v-if="!producto1.id">
              <SgaFrases @guardarFrases="guardarFrases" :dataPadre="{index: 1}"></SgaFrases>
            </b-col>
            <b-col sm="6" v-else>
            <div v-if="producto1.pictogramas.length">
              <b-row v-if="!producto1.sinPictograma">
                <b-col class="d-flex justify-content-center" v-for="(pictograma, index) in producto1.pictogramas" :key="index">
                  <b-img 
                    thumbnail
                    fluid
                    :src="pictograma.direccion"
                    :alt="pictograma.pictograma"
                    style="max-width: 125px; max-height: 125px;margin-bottom: 2rem;"
                  ></b-img>
                </b-col>
              </b-row>              
            </div>
            <b-row v-else>
                <b-col>
                  <span>
                    SIN PICTOGRAMA
                  </span>
                </b-col>
              </b-row>
            </b-col>
          <b-col sm="6" v-if="!producto2.id">
            <SgaFrases @guardarFrases="guardarFrases" :dataPadre="{index: 2}"></SgaFrases>       
          </b-col>
          <b-col sm="6" v-else>
            <b-row v-if="producto2.pictogramas.length">                   
              <b-col class="d-flex justify-content-center" v-for="(pictograma, index) in producto2.pictogramas" :key="index">
                <b-img 
                  thumbnail
                  fluid
                  :src="pictograma.direccion"
                  :alt="pictograma.pictograma"
                  style="max-width: 125px; max-height: 125px;margin-bottom: 2rem;"
                ></b-img>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col>
                <span>
                  SIN PICTOGRAMA
                </span>
              </b-col>
            </b-row>
          </b-col>
        </b-row>             
        <b-row class="d-flex justify-content-between"> 
            <b-col sm="10">
                <b-button @click="regresarPaso" class="mr-2">
                    Anterior
                </b-button>
                <b-button @click="$emit('volverMatriz')">
                    Cancelar
                </b-button>
            </b-col>
            <b-col class="d-flex justify-content-end" sm="2">          
                <b-button variant="primary" @click="validarUNSga" :disabled="siguientePaso">
                    Siguiente
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import loader from './../../containers/loader'
import SgaFrases from './../productos/sistemasclasificacion/sga/SgaFrases';

export default {
    name:'sga',
    props:['admin'],
    data(){
        return{
            loading: false,
            pasoActual: 2
        };
    },
    components: {
        loader,
        SgaFrases
    },    
    methods:{        
        guardarFrases(e) {
          let data = {index: e.index, values: e.values}
          this.setSelectedSga(data);
        },
        regresarPaso() {
          this.setPaso(1);
        },
        async validarUNSga() {
          this.load(true);
          await this.validarUNSgaProductos();
          this.load(false);
        },     
        ...mapActions('matrizCompatibilidad', [
          'validarUNSgaProductos',
          'guardarComparativaProductos'
        ]),
        ...mapActions('sga', [
            'getJsonSga'
        ]),
        ...mapMutations('dashboard', [
            'load'
        ]),
        ...mapMutations('matrizCompatibilidad', [
            'setModalMatriz',
            'setPaso',
            'setSelectedSga'
        ])
    },
    computed:{
      siguientePaso() {
          if (this.producto1.selectedSga.length && this.producto2.selectedSga.length) {
            return false;
          }

          if (this.producto1.selectedSga.length && this.producto2.id) {
            return false;
          }

          if (this.producto1.id && this.producto2.selectedSga.length) {
            return false;
          }

          return true;
        },
        ...mapState('matrizCompatibilidad', [
            'producto1',
            'producto2',
            'preguntas',
            'compatibilidad_un',
            'selectedEmpresa'
        ]),
        ...mapState('sga', [
            "fisicos",
            "salud",
            "ambiental",
            "peligrosas",
            "pictogramas",
        ]),
    },
}
</script>
<style scoped>
.tituloSga {
  font-size: 13pt;
}
.productoNom {
  font-size: 11pt;
}
.titulo {
  font-size: 13pt;
}
</style>
